import { Checkbox as CheckboxMUI, FormControlLabel } from "@material-ui/core";
import { CheckboxProps } from "./types";

function Checkbox({
  checked,
  onChange,
  name,
  text,
  ...rest
}: Readonly<CheckboxProps>) {
  return (
    <div>
      {!text && (
        <CheckboxMUI
          name={name}
          checked={checked}
          onChange={onChange}
          color="primary"
          {...rest}
        />
      )}
      {text && (
        <FormControlLabel
          control={
            <CheckboxMUI
              name={name}
              checked={checked}
              onChange={onChange}
              color="primary"
              {...rest}
            />
          }
          label={text}
        />
      )}
    </div>
  );
}

export default Checkbox;
